import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  mutation voteOnNarrative($input: VoteNarrativeInput!) {
    voteOnNarrative(input: $input) {
      narrative {
        voteCount {
          upvotes
        }
      }
    }
  }
`);

type Args = VariablesOf<typeof QUERY>['input'];

export const mutationFn = async ({ narrativeId }: Args) => {
  const { errors, voteOnNarrative } = await gqlClient.request(QUERY, {
    input: {
      narrativeId,
    },
  });

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return voteOnNarrative;
};
